import isEmpty from 'lodash/isEmpty';

import type { AbsoluteTimeRange } from 'views/logic/queries/Query';
import type { FieldFilters, FieldsOperator, InclusionType } from 'data-lake/Types';
import { BOTH_INCLUSION_TYPE } from 'data-lake/Constants';
import type { DateTime, DateTimeFormats } from 'util/DateTime';
import { isValidDate } from 'util/DateTime';

type FormatTime = (time: DateTime, format?: DateTimeFormats) => string;
export const getDefaultValues = (
  formatTime: FormatTime,
  timeRange?: AbsoluteTimeRange,
  dataLakeId?: string,
  streamIds?: Array<string>,
  defaultFieldFilters: Array<FieldFilters> = [],
  defaultFieldOperator: FieldsOperator = 'AND',
) => {
  const from = timeRange?.from || new Date().setMinutes(0, 0);
  const to = timeRange?.to || new Date().setMinutes(0, 0);

  return {
    inclusionType: BOTH_INCLUSION_TYPE as InclusionType,
    dataLakeId,
    streamIds,
    fieldFilters: defaultFieldFilters,
    operator: defaultFieldOperator,
    nextTimeRange: {
      type: 'absolute' as const,
      from: formatTime(from),
      to: formatTime(to),
    },
  };
};
export const getRangeValidationErrors = (
  from: string,
  to: string,
): { nextTimeRange?: { from?: string; to?: string } } => {
  const formatError = 'Format must be: YYYY-MM-DD [HH:mm].';
  const rangeError = 'The "To" date must come after the "From" date.';
  let errors = {};

  if (!from) {
    errors = { ...errors, from: 'The "From" field is required.' };
  }

  if (!to) {
    errors = { ...errors, to: 'The "To" field is required.' };
  }

  if ((from && !isValidDate(from)) || (to && !isValidDate(to))) {
    errors = { ...errors, from: formatError };
  }

  if (from >= to) {
    errors = { ...errors, to: rangeError };
  }

  if (isEmpty(errors)) return {};

  return { nextTimeRange: errors };
};
